import Footer from './Footer'
import Header from './Header'
import { Outlet } from 'react-router-dom'
import ScrollToTop from "../components/ScrollToTop/ScrollToTop";

const RootLayout = () => {
    return (
        <div className="flex flex-col min-h-screen">
            <Header />
            <ScrollToTop />
            <main className="flex-grow flex flex-col">
                <Outlet />
            </main>
            <Footer />
        </div>
    )
}

export default RootLayout